import { Edit, CardActions, ListButton, RefreshButton } from "react-admin";
import React from "react";

import BillTypeForm from "./BillTypeForm";

const BillTypeTitle = ({ record }) => {
  return (
    <span>
      {`ประเภทบิล "${record.name}"`}
    </span>
  );
};

const Actions = ({ basePath, data, resource }) => (
  <CardActions>
    <ListButton basePath={basePath} />
    {/* <DeleteButton basePath={basePath} record={data} resource={resource} /> */}
    <RefreshButton />
  </CardActions>
);

// const Title = translate(LineTitle);

export const BillTypeEdit = props => (
  <Edit actions={<Actions />} title={<BillTypeTitle />} {...props}>
    <BillTypeForm />
  </Edit>
);



// WEBPACK FOOTER //
// ./src/components/billtype/BillTypeEdit.js